export enum PremiumServiceParticipantsLimit {
  Unlimited = "Unlimited",
  SetLimit = "Set Limit",
  LimitPerEvent = "Limit Per Event",
  LimitPerTimeSlot = "Limit per time slot"
}